import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { AttributeType, gl } from '@antv/l7-core';
import { polygonFillTriangulation } from '@antv/l7-utils';
import BaseModel from "../../core/BaseModel";
import { polygonTriangulationWithCenter } from "../../core/triangulation";
/* babel-plugin-inline-import '../shaders/polygon_frag.glsl' */
var polygon_frag = "varying vec4 v_color;\n#pragma include \"picking\"\n\nvoid main() {\n  gl_FragColor = v_color;\n  gl_FragColor = filterColor(gl_FragColor);\n}\n";
/* babel-plugin-inline-import '../shaders/polygon_linear_frag.glsl' */
var polygon_linear_frag = "#pragma include \"picking\"\nuniform float u_opacitylinear: 0.0;\nuniform float u_dir: 1.0;\nvarying vec3 v_linear;\nvarying vec2 v_pos;\nvarying vec4 v_Color;\n\n\nvoid main() {\n   gl_FragColor = v_Color;\n  if(u_opacitylinear > 0.0) {\n    gl_FragColor.a *= u_dir == 1.0 ? 1.0 - length(v_pos - v_linear.xy)/v_linear.z : length(v_pos - v_linear.xy)/v_linear.z;\n  }\n  gl_FragColor = filterColor(gl_FragColor);\n}\n";
/* babel-plugin-inline-import '../shaders/polygon_linear_vert.glsl' */
var polygon_linear_vert = "attribute vec4 a_Color;\nattribute vec3 a_Position;\n\nuniform mat4 u_ModelMatrix;\n\nuniform float u_raisingHeight: 0.0;\n\nvarying vec4 v_Color;\n\n\n#pragma include \"projection\"\n#pragma include \"picking\"\n\nuniform float u_opacitylinear: 0.0;\n\nattribute vec3 a_linear;\nvarying vec3 v_linear;\nvarying vec2 v_pos;\n\nvoid main() {\n  if(u_opacitylinear > 0.0) {\n    v_linear = a_linear;\n    v_pos = a_Position.xy;\n  }\n  v_Color = vec4(a_Color.xyz, a_Color.w * opacity);\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n  project_pos.z += u_raisingHeight;\n\n  if(u_CoordinateSystem == COORDINATE_SYSTEM_LNGLAT || u_CoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSET) {\n    float mapboxZoomScale = 4.0/pow(2.0, 21.0 - u_Zoom);\n    project_pos.z *= mapboxZoomScale;\n    project_pos.z += u_raisingHeight * mapboxZoomScale;\n  }\n\n   gl_Position = project_common_position_to_clipspace_v2(vec4(project_pos.xyz, 1.0));\n  setPickingColor(a_PickingColor);\n}";
/* babel-plugin-inline-import '../shaders/polygon_vert.glsl' */
var polygon_vert = "attribute vec4 a_Color;\nattribute vec3 a_Position;\n\nuniform mat4 u_ModelMatrix;\n\n\nuniform float u_raisingHeight: 0.0;\n\nvarying vec4 v_color;\n\n\n#pragma include \"projection\"\n#pragma include \"picking\"\n\nvoid main() {\n  // cal style mapping - \u6570\u636E\u7EB9\u7406\u6620\u5C04\u90E8\u5206\u7684\u8BA1\u7B97\n\n  // cal style mapping - \u6570\u636E\u7EB9\u7406\u6620\u5C04\u90E8\u5206\u7684\u8BA1\u7B97\n\n  v_color = vec4(a_Color.xyz, a_Color.w * opacity);\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n  // gl_Position = project_common_position_to_clipspace(vec4(project_pos.xyz, 1.0));\n\n  project_pos.z += u_raisingHeight;\n\n  if(u_CoordinateSystem == COORDINATE_SYSTEM_LNGLAT || u_CoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSET) {\n    float mapboxZoomScale = 4.0/pow(2.0, 21.0 - u_Zoom);\n    project_pos.z *= mapboxZoomScale;\n    project_pos.z += u_raisingHeight * mapboxZoomScale;\n  }\n\n \n  gl_Position = project_common_position_to_clipspace_v2(vec4(project_pos.xyz, 1.0));\n\n  setPickingColor(a_PickingColor);\n}\n\n";
var FillModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(FillModel, _BaseModel);
  var _super = _createSuper(FillModel);
  function FillModel() {
    _classCallCheck(this, FillModel);
    return _super.apply(this, arguments);
  }
  _createClass(FillModel, [{
    key: "getUninforms",
    value: function getUninforms() {
      var _ref = this.layer.getLayerConfig(),
        _ref$raisingHeight = _ref.raisingHeight,
        raisingHeight = _ref$raisingHeight === void 0 ? 0 : _ref$raisingHeight,
        _ref$opacityLinear = _ref.opacityLinear,
        opacityLinear = _ref$opacityLinear === void 0 ? {
          enable: false,
          dir: 'in'
        } : _ref$opacityLinear;
      return _objectSpread({
        u_raisingHeight: Number(raisingHeight),
        u_opacitylinear: Number(opacityLinear.enable),
        u_dir: opacityLinear.dir === 'in' ? 1.0 : 0.0
      }, this.getStyleAttribute());
    }
  }, {
    key: "initModels",
    value: function () {
      var _initModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.buildModels());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initModels() {
        return _initModels.apply(this, arguments);
      }
      return initModels;
    }()
  }, {
    key: "buildModels",
    value: function () {
      var _buildModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$getModelParams, frag, vert, triangulation, type, model;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$getModelParams = this.getModelParams(), frag = _this$getModelParams.frag, vert = _this$getModelParams.vert, triangulation = _this$getModelParams.triangulation, type = _this$getModelParams.type;
              this.layer.triangulation = triangulation;
              _context2.next = 4;
              return this.layer.buildLayerModel({
                moduleName: type,
                vertexShader: vert,
                fragmentShader: frag,
                inject: this.getInject(),
                triangulation: triangulation,
                primitive: gl.TRIANGLES,
                depth: {
                  enable: false
                }
              });
            case 4:
              model = _context2.sent;
              return _context2.abrupt("return", [model]);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function buildModels() {
        return _buildModels.apply(this, arguments);
      }
      return buildModels;
    }()
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {
      var _ref2 = this.layer.getLayerConfig(),
        _ref2$opacityLinear = _ref2.opacityLinear,
        opacityLinear = _ref2$opacityLinear === void 0 ? {
          enable: false,
          dir: 'in'
        } : _ref2$opacityLinear;
      if (opacityLinear.enable) {
        this.styleAttributeService.registerStyleAttribute({
          name: 'linear',
          type: AttributeType.Attribute,
          descriptor: {
            name: 'a_linear',
            buffer: {
              // give the WebGL driver a hint that this buffer may change
              usage: gl.STATIC_DRAW,
              data: [],
              type: gl.FLOAT
            },
            size: 3,
            update: function update(feature, featureIdx, vertex) {
              return [vertex[3], vertex[4], vertex[5]];
            }
          }
        });
      }
    }
  }, {
    key: "getModelParams",
    value: function getModelParams() {
      var _ref3 = this.layer.getLayerConfig(),
        _ref3$opacityLinear = _ref3.opacityLinear,
        opacityLinear = _ref3$opacityLinear === void 0 ? {
          enable: false
        } : _ref3$opacityLinear;
      if (opacityLinear.enable) {
        return {
          frag: polygon_linear_frag,
          vert: polygon_linear_vert,
          type: 'polygonLinear',
          triangulation: polygonTriangulationWithCenter
        };
      } else {
        return {
          frag: polygon_frag,
          vert: polygon_vert,
          type: 'polygonFill',
          triangulation: polygonFillTriangulation
        };
      }
    }
  }]);
  return FillModel;
}(BaseModel);
export { FillModel as default };